<template>
  <div class="didacticiel">

    <div class="grid-container content-page"> 
      <div class="grid-x grid-margin-x">
        <div class="small-12 medium-6 medium-offset-3 cell center">
          <title-page class="title-page" attrpage="Globulo Quest" baseline="">Carte à imprimer</title-page>
        </div> 
        <div class="small-12 medium-6 medium-offset-3 cell ">  
          
          
          <div class="box-mascotte">
            <div class="bubble bottom txtleft">
              <carousel :perPage="1" paginationActiveColor="#de2128" paginationColor="#ccc" :paginationSize="15">
                <slide>
                  <h3>Bonjour {{ childName }}</h3>
                  <strong>Ton aventure Globulo Quest commence !</strong>
                  </br>
                  Il suffit de te rendre sur le site <strong>www.globulo-quest.org</strong> et de te connecter avec ces accès :
                  </br>
                  </br>
                  <strong>Identifiant :</strong> {{ childLogin }}
                  </br>
                  <strong>Mot de passe :</strong>
                  </br>
                  </br>
                  <bouton class="bt-print" @click="print">Imprimer ce message pour XXX</bouton>
                </slide>
              </carousel>
            </div>
            <img src="@/assets/images/mascotte/mascotte-red.png" alt="Globulo Quest mascotte" title="Globulo Quest mascotte"/>
          </div> 
            
            
        </div> 
      </div> 
    </div>    
  </div>    
</template>

<script>
  import TitlePage from '@/components/TitlePage'
  import Bouton from '@/components/Bouton'
  import { Carousel, Slide } from 'vue-carousel'
  
  export default {
    components: { TitlePage, Bouton, Carousel, Slide },
    methods: {
      print () {
        print();
      }
    },
    computed: {
      childName() {
        return this.$store.state.subaccounts.child.first_name
      },
      childLogin() {
        return this.$store.state.subaccounts.child.identifier
      }
    }
  }
</script>
